var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "design-layout"
  }, [_c("SvgIcon"), [_c("layout-top"), _c("layout-preview"), _c("layout-sortable"), _c("zoom")]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };